import React from 'react';
import { Helmet } from 'react-helmet';
import './legal.css';

const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions | Vasmi Group</title>
      </Helmet>
      <div className="legal-container">
        <h1>Terms & Conditions</h1>
        <p>Last updated: April 04, 2024</p>

        <section>
          <h2>1. Terms of Use</h2>
          <p>By accessing this website, we assume you accept these terms and conditions. Do not continue to use Vasmi Group if you do not agree to take all of the terms and conditions stated on this page.</p>
        </section>

        <section>
          <h2>2. License</h2>
          <p>Unless otherwise stated, Vasmi Group and/or its licensors own the intellectual property rights for all material on Vasmi Group. All intellectual property rights are reserved.</p>
          <p>You must not:</p>
          <ul>
            <li>Republish material from Vasmi Group</li>
            <li>Sell, rent or sub-license material from Vasmi Group</li>
            <li>Reproduce, duplicate or copy material from Vasmi Group</li>
            <li>Redistribute content from Vasmi Group</li>
          </ul>
        </section>

        <section>
          <h2>3. Service Provision</h2>
          <p>Vasmi Group provides digital marketing, software development, and recruitment services. Specific service agreements and contracts will govern the delivery and execution of these services.</p>
        </section>

        <section>
          <h2>4. User Comments</h2>
          <p>This Agreement shall begin on the date hereof. Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. Vasmi Group does not filter, edit, publish or review Comments prior to their presence on the website.</p>
        </section>

        <section>
          <h2>5. Contact Us</h2>
          <p>If you have any questions about these Terms and Conditions, please contact us at info@vasmigroup.com.</p>
        </section>
      </div>
    </>
  );
};

export default TermsAndConditions;
